export const locales = {
  KO: 'ko',
  EN: 'en',
} as const
